import { render, staticRenderFns } from "./TextOption.vue?vue&type=template&id=47584dfa&scoped=true&"
import script from "./TextOption.vue?vue&type=script&lang=js&"
export * from "./TextOption.vue?vue&type=script&lang=js&"
import style0 from "./TextOption.vue?vue&type=style&index=0&id=47584dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47584dfa",
  null
  
)

export default component.exports